import { Card, CardHeader, CardBody, Text, Flex, Button } from '@backstage/ui';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { RiShieldKeyholeLine, RiGitlabLine, RiMicrosoftLine, RiUser3Line, RiLogoutBoxRLine } from '@remixicon/react';
import { appTranslationRef } from '../../../../core/i18n';
import { SESSION_KEY } from '../../../auth';
import styles from '../../settings.module.css';

const providerIcons = {
  microsoft: RiMicrosoftLine,
  gitlab: RiGitlabLine,
  guest: RiUser3Line,
} as const;

export const AuthCard = () => {
  const { t } = useTranslationRef(appTranslationRef);
  const identityApi = useApi(identityApiRef);
  const provider = (localStorage.getItem(SESSION_KEY) ?? 'guest') as keyof typeof providerIcons;
  const ProviderIcon = providerIcons[provider] ?? providerIcons.guest;
  const providerLabel = t(`auth.${provider}`);

  const handleSignOut = async () => {
    localStorage.removeItem(SESSION_KEY);
    await identityApi.signOut();
    window.location.reload();
  };

  return (
    <Card>
      <CardHeader>
        <Flex gap="3" align="center">
          <RiShieldKeyholeLine size={18} className={styles.cardIcon} />
          <Text variant="title-small" weight="bold">
            {t('settings.auth.title')}
          </Text>
        </Flex>
      </CardHeader>
      <CardBody>
        <Flex direction="column" gap="4">
          <Flex direction="column" gap="2">
            <Text variant="body-x-small" color="secondary">
              {t('settings.auth.provider')}
            </Text>
            <div className={styles.providerBadge}>
              <ProviderIcon size={16} />
              <Text variant="body-small" weight="bold">{providerLabel}</Text>
            </div>
          </Flex>

          <div className={styles.divider} />

          <div className={styles.signOutZone}>
            <Text variant="body-small" color="secondary">
              {t('settings.auth.signOutDescription')}
            </Text>
            <Button
              variant="secondary"
              size="small"
              iconStart={<RiLogoutBoxRLine size={16} />}
              onPress={handleSignOut}
            >
              {t('settings.auth.signOut')}
            </Button>
          </div>
        </Flex>
      </CardBody>
    </Card>
  );
};
